import { Pagination, PagingParams } from "../models/pagination";
import agent from "../api/agent";
import { makeAutoObservable, reaction, runInAction } from "mobx";
import { IUpsertSettingsTaxRatesFormValues, SettingsTaxRateForTicketDto, SettingsTaxRatesDto } from "../models/pricing";

export default class MultipleTaxRatesStore {
    loadingMultipleTaxes = false;

    pagingParams = new PagingParams();
    pagination: Pagination | null = null;

    selectedSettingsTaxRate: SettingsTaxRatesDto | undefined = undefined;
    selectedMultipleTaxRates: SettingsTaxRatesDto[] | undefined = undefined;
    selectedSettingsTaxRateForTicket: SettingsTaxRateForTicketDto | undefined;

    MultipleTaxRatesRegistry = new Map<string | undefined, SettingsTaxRatesDto>();

    constructor() {
        makeAutoObservable(this);
        reaction(
            () => { },
            () => {
                this.MultipleTaxRatesRegistry.clear();
                this.loadMultipleTaxRates();
            }
        );
    }

    setSelectedSettingsTaxRate = (values: SettingsTaxRatesDto | undefined) => {
        this.selectedSettingsTaxRate = values;
    };

    setSelectedMultipleTaxRates = (values: SettingsTaxRatesDto[] | undefined) => {
        this.selectedMultipleTaxRates = values;
    }

    private setSettingsTaxRate = (comm: SettingsTaxRatesDto) => {
        if (comm?.updatedDate) {
            comm.updatedDate = new Date(comm.updatedDate);
        }
        this.MultipleTaxRatesRegistry.set(
            comm.id,
            comm
        );
    }

    loadMultipleTaxRateForTicket = async () => {
        this.loadingMultipleTaxes = true;
        try {
            const result = await agent.Pricing.getSettingsTaxRate();
            runInAction(() => {
                this.setSelectedSettingsTaxRateForTicket(result);
            });
            return result;
        } catch (error) {
            console.log(error);
        } finally {
            runInAction(() => {
                this.loadingMultipleTaxes = false;
            });
        }
    };

    loadMultipleTaxRates = async () => {
        this.setLoadingInitial(true);
        this.MultipleTaxRatesRegistry.clear();
        try {
            const result = await agent.Pricing.getSettingsTaxRates(this.axiosParams);
            runInAction(() => {
                result.data.forEach((x: SettingsTaxRatesDto) => this.setSettingsTaxRate(x))
            });
            this.setPagination(result.pagination);
        } catch (error) {
            console.log(error);
        } finally {
            runInAction(() => {
                this.setLoadingInitial(false);
            });
        }
    };


    createSettingsTaxRate = async (values: IUpsertSettingsTaxRatesFormValues) => {
        this.setLoadingInitial(true);
        try {
            await agent.Pricing.addSettingsTaxRate(values);
            runInAction(() => {
                this.MultipleTaxRatesRegistry.clear();
            });
        }
        catch (error) {
            console.log("Error:", error);
        }
        finally {
            runInAction(() => {
                this.setLoadingInitial(false);
            });
        }
    }

    updateSettingsTaxRate = async (settingsTaxRateId: string, values: IUpsertSettingsTaxRatesFormValues) => {
        this.setLoadingInitial(true);
        try {
            await agent.Pricing.updateSettingsTaxRate(settingsTaxRateId, values)
            runInAction(() => {
                this.setSelectedSettingsTaxRate(undefined);
            });
        }
        catch (error) {
            console.log("Error:", error);
        }
        finally {
            runInAction(() => {
                this.setLoadingInitial(false);
            });
        }
    }

    removeSettingsTaxRate = async (rateId: string) => {
        this.setLoadingInitial(true);
        try {
            await agent.Pricing.removeSettingsTaxRate(rateId);
            runInAction(() => {
                this.MultipleTaxRatesRegistry.clear();
            });
        }
        catch (error) {
            console.log("Error:", error);
        }
        finally {
            runInAction(() => {
                this.setLoadingInitial(false);
            });
        }

    }

    setLoadingInitial(value: boolean) {
        this.loadingMultipleTaxes = value;
    }
    get getTaxRates() {
        return Array.from(this.MultipleTaxRatesRegistry.values()).map(tx => tx);
    }
    get axiosParams() {
        const params = new URLSearchParams();
        params.append("pageNumber", this.pagingParams.pageNumber.toString());
        params.append("pageSize", this.pagingParams.pageSize.toString());
        return params;
    }


    setPagingParams = (pagingParams: PagingParams) => {
        this.pagingParams = pagingParams;
    };

    setPagination = (pagination: Pagination) => {
        this.pagination = pagination;
    }

    setSelectedSettingsTaxRateForTicket = (values: SettingsTaxRateForTicketDto) => {
        this.selectedSettingsTaxRateForTicket = values;
    };
}
